import MonthGroupReport from './month-group-report.vue'
export default MonthGroupReport
